export const messages = {
    error1: 'Number of source dealers should be > 0',
    error2: 'Invalid new dealer id. Please enter 10 character alphanumeric dealer id. Ex. TALF000000.',
    error3: 'New and Source dealer Ids cannot be same.',
    warningText: 'Please review source and new dealer ids carefully.',
    infoText: 'Proposal and customer data from source dealers will be migrated to new dealer.',
    processingInfoText: 'Migrating data from Source to New dealer.',
    mergeSuccessText: 'Completed successfully.',
    genericError: 'ERROR: There was an error duirng merge process.',
    importantInfo: ['a. Full data back-up has been done.',
        'b. ICS system changes have been completed for new and source dealers.',
        'c. New dealer should have at least two billing address versions created in Alfa core. Ex. TALF000000/1 and TALF000000/2'
    ]
}
